"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Spinner: true,
  SIZE: true
};
Object.defineProperty(exports, "SIZE", {
  enumerable: true,
  get: function () {
    return _constants.SIZE;
  }
});
exports.Spinner = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("./styled-components");
var _constants = require("./constants");
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/ // Flow
const Spinner = props => {
  return /*#__PURE__*/_react.default.createElement(_styledComponents.StyledSpinner, _extends({
    role: "progressbar",
    "aria-label": "loading",
    "aria-busy": "true"
  }, props));
};
exports.Spinner = Spinner;
Spinner.displayName = 'StyledSpinner';
Spinner.__STYLETRON__ = _styledComponents.StyledSpinner.__STYLETRON__;